import { map } from 'lodash-es';
import { Route, Switch, useParams } from 'react-router';

import AdminConsolePlaceholder from '../AdminConsolePlaceholder';
import AdminAccountManagementEmpty from './AdminAccountManagementEmpty';
import AdminAccountPickList from './AdminAccountPickList';
import AdminAccountProfile from './AdminAccountProfile';
import AdminAccountSelector from './AdminAccountSelector';
import AdminAccountSidebar from './AdminAccountSidebar';
import {
  ADMIN_ACCOUNT_SECTIONS,
  getSectionRoute,
} from './adminAccountSections';
import { useAdminAccountManagementStyles } from './AdminAccountManagement.styles';
import { ADMIN_PICKLIST_SECTIONS } from './detail/adminPickListSections';

export default function AdminAccountManagement() {
  const { accountNumber } = useParams();
  const { styles } = useAdminAccountManagementStyles();

  return (
    <div className={styles.management}>
      <div className={styles.sidebar}>
        <AdminAccountSelector accountNumber={accountNumber} />
        {accountNumber && <AdminAccountSidebar accountNumber={accountNumber} />}
      </div>
      <div className={styles.content}>
        {accountNumber ? (
          <Switch>
            {map(ADMIN_ACCOUNT_SECTIONS, section => (
              <Route
                key={section.key}
                path={getSectionRoute(section)}
                exact={section.exact}
              >
                {section.key === 'accountProfile' && (
                  <AdminAccountProfile accountNumber={accountNumber} />
                )}
                {ADMIN_PICKLIST_SECTIONS[section.key] && (
                  <AdminAccountPickList
                    accountNumber={accountNumber}
                    section={ADMIN_PICKLIST_SECTIONS[section.key]}
                  />
                )}
                {section.key !== 'accountProfile' &&
                  !ADMIN_PICKLIST_SECTIONS[section.key] && (
                    <AdminConsolePlaceholder />
                  )}
              </Route>
            ))}
          </Switch>
        ) : (
          <AdminAccountManagementEmpty />
        )}
      </div>
    </div>
  );
}
